import { hasAc, hasHalfBoard, hasHost } from '../helpers/crewFinder';

const initialState = {
  fetching: true,
  items: [],
  filtered: [],
  bookmarkedCrewFinders: [],
  currentCrewFinderData: {}
};

const filterCrewFinder = (state, payload) => {
  const {
    hullType = [],
    amenities = [],
    weekFilter = [],
    destinationFilter = [],
    extras = [],
    yearFilter = [],
    countryFilter = [],
    favourites = null
  } = payload;
  return state.items.filter(item => {
    if (hullType.length > 0 && hullType.indexOf(item.hullType.toLowerCase()) === -1) {
      return false;
    }
    if (amenities.length > 0 && amenities.indexOf('Air Conditioning') !== -1 && !item.hasAc) {
      return false;
    }
    if (weekFilter.length && !weekFilter.includes(`${item.week.week}`)) {
      return false;
    }
    if (destinationFilter.length && !destinationFilter.includes(`${item.destination.id}`)) {
      return false;
    }
    if (countryFilter.length && !countryFilter.includes(`${item.destination.country}`)) {
      return false;
    }
    if (yearFilter.length && !yearFilter.includes(new Date(item.week.beginDate).getFullYear().toString())) {
      return false;
    }
    // if (yearFilter.length && !yearFilter.includes(`${item.week.year}`)) {
    //   return false;
    // }
    if (extras.length) {
      if (extras.includes('Host')) {
        if (!hasHost(item)) return false;
      }
      if (extras.includes('Half Board')) {
        if (!hasHalfBoard(item)) return false;
      }
      if (extras.includes('Air Conditioning')) {
        if (!hasAc(item)) return false;
      }
    }
    if (favourites && !state.bookmarkedCrewFinders.some(b => b.id === item.id)) {
      return false;
    }
    return true;
  });
};

const crewFinder = (state = initialState, action) => {
  switch (action.type) {
  case 'FETCHING_CREW_FINDER_DATA':
    return {
      ...state,
      fetching: true
    };
  case 'SAVE_CREW_FINDER_DATA':
    return {
      ...state,
      bookmarkedCrewFinders: action.crewFinderData.data.bookmarkedCrewFinders,
      filtered: action.crewFinderData.data.items.sort((a, b) => a.crewFinder.price - b.crewFinder.price),
      items: action.crewFinderData.data.items.sort((a, b) => a.crewFinder.price - b.crewFinder.price),
      fetching: false
    };
  case 'FILTER_CREW_FINDER':
    return {
      ...state,
      filtered: filterCrewFinder(state, action.payload)
    };
  case 'SAVE_CREW_FINDER_MEMBERS_DATA':
    return {
      ...state,
      currentCrewFinderData: { crewFinderMemberData: action.crewFinderMemberData, id: action.crewFinderId }
    };
  default:
    return state;
  }
};

export default crewFinder;
